/**
 * Parent/guardian sections (parent1 + parent2) — shared between BasicStep
 * (speech clinics) and DetailsStep (all other clinic types).
 */
function ParentsFields({ form }) {
  const { formData, errors, handleNestedChange, formatPhone, formatIdNumber } =
    form;

  const renderParent = (key, title) => (
    <div className="parent-section" key={key}>
      <h4>{title}</h4>
      <div className="form-row three-cols">
        <div className="form-group">
          <label>שם מלא</label>
          <input
            type="text"
            value={formData[key].name}
            onChange={(e) => handleNestedChange(key, "name", e.target.value)}
            placeholder="שם ההורה"
          />
        </div>
        <div className="form-group">
          <label>טלפון</label>
          <input
            type="tel"
            value={formData[key].phone}
            onChange={(e) =>
              handleNestedChange(key, "phone", formatPhone(e.target.value))
            }
            placeholder="0501234567"
            dir="ltr"
          />
        </div>
        <div className="form-group">
          <label>תעודת זהות</label>
          <input
            type="text"
            inputMode="numeric"
            maxLength={9}
            value={formData[key].id || ""}
            onChange={(e) =>
              handleNestedChange(key, "id", formatIdNumber(e.target.value))
            }
            placeholder="123456789"
            dir="ltr"
            className={errors[`${key}Id`] ? "error" : ""}
          />
          {errors[`${key}Id`] && (
            <span className="error-text">{errors[`${key}Id`]}</span>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <h3 className="section-title">הורים / אפוטרופוסים</h3>
      {renderParent("parent1", "הורה 1")}
      {renderParent("parent2", "הורה 2")}
    </>
  );
}

export default ParentsFields;
